import { useParams } from 'react-router-dom';

import { useFeatureIsOn } from 'src/common/growthbook';
import { B2BUserHelper } from 'src/common/helpers';
import { useGetUserQuery } from 'src/common/slices';

const ExperimentRoomReplacementMap = new Map<string, string>([
  ['offensivesecurityintro', 'offensivesecurityintrokK'],
  ['defensivesecurityintro', 'defensivesecurityintroqW'],
]);

// Cutoff date to force-enable DSI room replacement for newly signed up users
const ROOM_REPLACEMENT_DSI_SIGNUP_ENABLE_AFTER = new Date('2025-10-07T16:00:00.000Z');

export const useRoomCode = () => {
  const { roomCode: originalRoomCode } = useParams();
  const { data: userData } = useGetUserQuery();
  const { isBusinessUser } = B2BUserHelper(userData?.data?.user);

  const isOffensiveSecurityIntroEnabled = useFeatureIsOn('improvement-offensive-security-intro');
  const userSignupDate = userData?.data?.user?.dateSignUp;
  const isSignupAfterCutoff =
    !!userSignupDate && new Date(userSignupDate).getTime() >= ROOM_REPLACEMENT_DSI_SIGNUP_ENABLE_AFTER.getTime();
  const isDefensiveSecurityIntroEnabled = useFeatureIsOn('improvement-defensive-security-intro') || isSignupAfterCutoff;
  const isDefensiveSecurityIntroV2Enabled = useFeatureIsOn('improvement-defensive-security-intro-v2');

  const getIsFeatureEnabled = () => {
    if (!originalRoomCode) return false;

    switch (originalRoomCode) {
      case 'offensivesecurityintro':
        return isOffensiveSecurityIntroEnabled;
      case 'defensivesecurityintro':
        return isDefensiveSecurityIntroV2Enabled || isDefensiveSecurityIntroEnabled;
      default:
        return false;
    }
  };

  const isFeatureOn = getIsFeatureEnabled();
  const isExperimentEnabled = originalRoomCode && isFeatureOn && userData && !isBusinessUser;

  if (isExperimentEnabled && originalRoomCode === 'defensivesecurityintro' && isDefensiveSecurityIntroV2Enabled) {
    return 'defensivesecurityintroQR';
  }

  return isExperimentEnabled ? ExperimentRoomReplacementMap.get(originalRoomCode) : originalRoomCode;
};
